// Use this array template on pages requiring charts
// replace values below with chart info
// const charts = [
//   {
//     file: '/sites/dolgov/files/WHD/csv/All_Acts.csv',
//     type: 'bar',
//     title: 'All Acts',
//     id: "#allChart"
//   },
//   {
//     file: '/sites/dolgov/files/WHD/csv/FairLabor_MinWage.csv',
//     type: 'line',
//     title: 'Fair Labor Standards Act - Minimum Wage',
//     id: '#FairLabor'
//   },
//   {
//     file: '/sites/dolgov/files/WHD/csv/FairLabor_Overtime.csv',
//     type: 'line',
//     title: 'Fair Labor Standards Act - Overtime',
//     id: '#OverTime'
//   },
//   {
//     file: '/sites/dolgov/files/WHD/csv/Low_Wages_FY_gen.csv',
//     type: 'bar',
//     title: 'Low Wage, High Violation Industries',
//     id: '#LowWagesChart'
//   },
//   {
//     file: '/sites/dolgov/files/WHD/csv/Outreach_Events.csv',
//     type: 'line',
//     title: 'Outreach',
//     id: '#OutreachEvents'
//   }
// ];

// jQuery(function() {
//   if ( typeof charts === "undefined" || charts === null ) {
//     return false;
//   } else {
//     setupChart(charts[0]);
//     setupChart(charts[1]);
//     setupChart(charts[2]);
//     setupChart(charts[3]);
//     setupChart(charts[4]);
//     // charts.forEach(function (whdChart) {
//     //   setupChart(whdChart);
//     // });
//   }
// });

// function setupChart(whdChart) {
//   var xAxis = [];
//   var cols = [];
//   var legend = [];
//   let rowCount = 0;
//
//   d3.csv(whdChart.file, function (d) {
//     rowCount++;
//     let col = [d.year];
//     legend.push(col);
//     for (var i in d) {
//       if (i !== 'year') {
//         col.push(+d[i]);
//       }
//     }
//     cols.push(col);
//     if (rowCount === 1) {
//       Object.keys(d).forEach(function (item) {
//         if (item !== 'year') {
//           // xAxis.push(+item);
//           xAxis.push(item);
//         }
//       });
//     }
//     return {
//       xCategories : xAxis,
//       columns : cols,
//       legend : legend
//     };
//   }).then(function(data) {
//     var chart = generateChart(whdChart, data[0].columns, data[0].xCategories);
//     data[0].legend.forEach(function (item, index) {
//       if (index !== 0) {
//         chart.hide(item);
//       }
//     });
//     chart.show(legend[0]);
//   });
// }
//
// function generateChart(whdChart, cols, xCategories) {
//   var chart = c3.generate({
//     bindto: whdChart.id,
//     title: {
//       text: whdChart.title,
//       position: 'top-center'
//     },
//     size: {
//       width: 900
//     },
//     data: {
//       columns: cols,
//       type: whdChart.type
//     },
//     color: {
//       pattern: ['#7cb5ec', '#434348', '#90ed7d', '#f7a35c', '#8085e9', '#f15c80']
//     },
//     axis: {
//       x: {
//         type: 'category',
//         categories: xCategories,
//         label: {
//           text: 'Fiscal Year',
//           position: 'center'
//         }
//       },
//       y: {
//         tick: {
//           format: d3.format(",")
//         }
//       }
//     }
//   });
//   return chart;
// }
